module.exports = __webpack_public_path__ + "img/coin-50x.9706470a.svg";